<script>
/**
 * 通用「图标 + 标题 + 描述」卡片（关于我们的使命/愿景/价值观、里程碑等）
 */
import NhSvgIcon from './NhSvgIcon.vue'

export default {
  name: 'NhFeatureCard',
  components: { NhSvgIcon },
  props: {
    icon: { type: String, default: '' },
    title: { type: String, default: '' },
    desc: { type: String, default: '' },
    delay: { type: [Number, String], default: undefined }
  }
}
</script>

<template>
  <div v-reveal="delay" class="feature">
    <div v-if="icon" class="f-ic"><NhSvgIcon :name="icon" /></div>
    <h3>{{ title }}</h3>
    <p>{{ desc }}</p>
  </div>
</template>
